import { render, staticRenderFns } from "./ChatRouting.vue?vue&type=template&id=267c2998"
import script from "./ChatRouting.vue?vue&type=script&lang=js"
export * from "./ChatRouting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports